import { useEffect } from 'react';
import { AlmeApiUtils } from '../AlmeApiUtils';
import { AlmeMessageHandlerUtils } from '../post-message/AlmeMessageHandlerUtils';
import useDelayPostMessageHandler from '../post-message/useDelayPostMessageHandler';
import { getClientCommunicator } from '../post-message/PostMessageListener';
export const usePostMessageListener = (almeState, setAlmeState, appConfig, almeApi, liveChatNotificationApi, ivaSetChatStatus) => {
    const setDelayPostMessageHandle = useDelayPostMessageHandler(almeState, setAlmeState, appConfig, ivaSetChatStatus);
    /**
     * Create post message handlers and listen for post messagess
     */
    useEffect(() => {
        const almeMessageHandlerUtils = new AlmeMessageHandlerUtils(almeState, setAlmeState, appConfig, new AlmeApiUtils(almeState, setAlmeState, appConfig, almeApi, liveChatNotificationApi), setDelayPostMessageHandle, ivaSetChatStatus);
        const messageHandleCallback = almeMessageHandlerUtils.Handle.bind(almeMessageHandlerUtils);
        const clientCommunicator = getClientCommunicator(appConfig.allowedOrigins);
        const callbackId = clientCommunicator.addAlmeMessageListener(messageHandleCallback);
        return () => {
            clientCommunicator.removeAlmeMessageListener(callbackId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [almeState, setAlmeState, appConfig, setDelayPostMessageHandle, ivaSetChatStatus]);
};
